export const getSizedUrl = (url, width, height) => {
    const index = url.lastIndexOf('.');
    const dimensions = `${width || ''}x${height || ''}`;

    return `${url.slice(0, index)}_${dimensions}${url.slice(index)}`;
};

export const createSource = (url, dimensions, media) => {
    const { width, height } = dimensions;

    const x1 = getSizedUrl(url, width, height);
    const x2 = getSizedUrl(url, width * 2, height * 2);

    return `<source
        srcset="${getSizedUrl(url, 30)}"
        data-srcset="${x1}, ${x2} 2x"
        media="${media || `(min-width: ${width}px)`}"
    >`;
};

export const createSourceSet = (url, sets) => {
    return sets
        .map(({ dimensions, media }) => {
            return createSource(url, dimensions, media);
        })
        .join('');
};
